module.exports = __webpack_public_path__ + "img/do.40296d5a.png";